export default "__VITE_ASSET__NeMbFSQM__"